// extracted by mini-css-extract-plugin
export default {"submitButton":"Carousel_submitButton__mrzK-"};